<div fxLayout="column" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayoutAlign="start center">
        <!-- <ng-container *ngIf="carpetaActual == ''"> -->
          <button mat-button (click)="nuevo_gotoRaiz()" *ngIf="versionCloudNueva">
            <mat-icon [ngClass]="{'negritas s-24':!idCarpetaActual, 'secondary-text s-24': idCarpetaActual}">home</mat-icon>
          </button>
          <button mat-button (click)="gotoRaiz()" *ngIf="!versionCloudNueva">
            <mat-icon [ngClass]="{'negritas s-24':!idCarpetaActual, 'secondary-text s-24': idCarpetaActual}">home</mat-icon>
          </button>
          <!-- <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
          <button mat-button>
            <h2 class="secondary-text">home</h2>
          </button> -->
          <ng-container *ngFor="let carpeta of historial; last as last">
            <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
            <button mat-button>
              <ng-container *ngIf="versionCloudNueva; else historial_anterior">
                <h2 *ngIf="!carpeta.carpetaDef" [ngClass]="{'secondary-text':!last, 'negritas': last}" (click)="nuevo_getCarpeta(carpeta)">{{carpeta.nombre}}</h2>
                <h2 *ngIf="carpeta.carpetaDef" [ngClass]="{'secondary-text':!last, 'negritas': last}" (click)="nuevo_getCarpeta(carpeta)">{{'FILEMANAGER.CARPETASDEFAULT.'+carpeta.nombre | translate}}</h2>
              </ng-container>
              <ng-template #historial_anterior>
                <h2 *ngIf="!carpeta.carpetaDef" [ngClass]="{'secondary-text':!last, 'negritas': last}" (click)="getCarpeta(carpeta)">{{carpeta.nombre}}</h2>
                <h2 *ngIf="carpeta.carpetaDef" [ngClass]="{'secondary-text':!last, 'negritas': last}" (click)="getCarpeta(carpeta)">{{'FILEMANAGER.CARPETASDEFAULT.'+carpeta.nombre | translate}}</h2>
              </ng-template>
            </button>
          </ng-container>

        <!-- </ng-container> -->
        <!-- <ng-container *ngIf="carpetaActual != ''">
            <mat-icon (click)="getListaArchivos('')" class="secondary-text s-24 botonNav">home</mat-icon>
            <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
            <span (click)="getListaArchivos('')" class="botonNav"><h2>Home</h2></span>
            <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
            <span class=""><h2>{{carpetaActual}}</h2></span>
        </ng-container> -->
    </div>

</div>

<input hidden type="file" #nuevoArchivo (change)="guardaArchivoNuevo($event)"/>
<mat-menu #opcionesCloud="matMenu">
  <button mat-menu-item (click)="nuevoArchivo.click()">
    <mat-icon class="mr-20">attachment</mat-icon>
    {{'FILEMANAGER.MENU.ARCHIVO' | translate}}
  </button>
  <button mat-menu-item (click)="nuevo_guardaCarpeta()" *ngIf="versionCloudNueva">
    <mat-icon class="mr-20">create_new_folder</mat-icon>
    {{'FILEMANAGER.MENU.CARPETA' | translate}}
  </button>
  <button mat-menu-item (click)="guardaCarpeta()" *ngIf="!versionCloudNueva">
    <mat-icon class="mr-20">create_new_folder</mat-icon>
    {{'FILEMANAGER.MENU.CARPETA' | translate}}
  </button>
</mat-menu>

<button class="botonAgregar" mat-raised-button [matMenuTriggerFor]="opcionesCloud">
  <mat-icon class="mr-20">add_circle_outline</mat-icon>
  {{'FILEMANAGER.MENU.BOTON' | translate}}
</button>

<!-- <mat-table *ngIf="listaArchivosEmpresa" class="mat-elevation-z3 p-20" [dataSource]="listaArchivosEmpresa.archivos" [@animateStagger]="{value:'50'}"> -->
<mat-table *ngIf="listaArchivos" class="mat-elevation-z3 p-20 mt-20" [dataSource]="listaArchivos" [@animateStagger]="{value:'50'}">

    <!-- Name Column -->
    <ng-container matColumnDef="icono">
        <mat-header-cell *matHeaderCellDef fxFlex="64px"></mat-header-cell>
        <mat-cell *matCellDef="let fila" fxFlex="64px">
            <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c1_existe">
            </ng-container>
            <ng-template #c1_existe>
              <ng-container *ngIf="fila.tipoArchivo == 'folder'; else c1_archivo">
                <mat-icon class="type-icon">folder</mat-icon>
              </ng-container>
              <ng-template #c1_archivo>
                <mat-icon class="type-icon">insert_drive_file</mat-icon>
              </ng-template>
            </ng-template>
        </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="nombre">
        <mat-header-cell *matHeaderCellDef>
            <h2><b>{{'FILEMANAGER.LISTA.TITULOS.NOMBRE' | translate}}</b></h2>
        </mat-header-cell>
        <mat-cell *matCellDef="let fila">
            <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c2_existe">
              {{'FILEMANAGER.LISTA.TOOLTIP.VACIO' | translate}}
            </ng-container>
            <ng-template #c2_existe>
              <ng-container *ngIf="fila.tipoArchivo == 'folder'; else c2_archivo">
                <ng-container *ngIf="versionCloudNueva; else nombre_anterior">
                  <b class="botonNav" *ngIf="!fila.carpetaDef" (click)="nuevo_getCarpeta(fila)" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.OPENFOLDER' | translate}}">{{fila.nombre}}</b>
                  <b class="botonNav" *ngIf="fila.carpetaDef" (click)="nuevo_getCarpeta(fila)" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.OPENFOLDER' | translate}}">{{'FILEMANAGER.CARPETASDEFAULT.'+fila.nombre | translate}}</b>
                </ng-container>
                <ng-template #nombre_anterior>
                  <b class="botonNav" *ngIf="!fila.carpetaDef" (click)="getCarpeta(fila)" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.OPENFOLDER' | translate}}">{{fila.nombre}}</b>
                  <b class="botonNav" *ngIf="fila.carpetaDef" (click)="getCarpeta(fila)" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.OPENFOLDER' | translate}}">{{'FILEMANAGER.CARPETASDEFAULT.'+fila.nombre | translate}}</b>
                </ng-template>
              </ng-container>
              <ng-template #c2_archivo>
                {{fila.nombre}}
              </ng-template>
            </ng-template>
        </mat-cell>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="Extensión">
        <mat-header-cell *matHeaderCellDef>
            <h2><b>{{'FILEMANAGER.LISTA.TITULOS.EXTEN' | translate}}</b></h2>
        </mat-header-cell>
        <mat-cell *matCellDef="let fila">
            <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c3_existe">
            </ng-container>
            <ng-template #c3_existe>
              <ng-container *ngIf="fila.tipoArchivo != 'folder'">
                {{fila.tipo}}
              </ng-container>
            </ng-template>
        </mat-cell>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="Fecha de carga">
        <mat-header-cell *matHeaderCellDef>
            <h2><b>{{'FILEMANAGER.LISTA.TITULOS.FECHA' | translate}}</b></h2>
        </mat-header-cell>
        <mat-cell *matCellDef="let fila">
          <!-- {{fila.fechaRegistro | slice: 0:10 | date:"fullDate":'':idiomaActual}} -->
          <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c4_existe">
          </ng-container>
          <ng-template #c4_existe>
            <ng-container *ngIf="fila.tipoArchivo == 'folder'; else c4_archivo">
              {{fila.createdAt |date:"short":'':idiomaActual}}
            </ng-container>
            <ng-template #c4_archivo>
              {{fila.createdAt |date:"short":'':idiomaActual}}
            </ng-template>
          </ng-template>
        </mat-cell>
    </ng-container>

    <!-- tamaño Column -->
    <ng-container matColumnDef="tamaño">
        <mat-header-cell *matHeaderCellDef>
            <h2><b>{{'FILEMANAGER.LISTA.TITULOS.TAMANIO' | translate}}</b></h2>
        </mat-header-cell>
        <mat-cell *matCellDef="let fila">
          <!-- {{fila.fechaRegistro | slice: 0:10 | date:"fullDate":'':idiomaActual}} -->
          <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c5_existe">
          </ng-container>
          <ng-template #c5_existe>
            <ng-container *ngIf="fila.tipoArchivo == 'folder'; else c5_archivo">
              <!-- {{fila.createdAt |date:"short":'':idiomaActual}} -->
              -
            </ng-container>
            <ng-template #c5_archivo>
              <!-- {{fila.tamanio | bytes: 'kB'}} -->
              {{(fila.tamanio / 1024)| number:'1.0-0'}} KB
            </ng-template>
          </ng-template>
        </mat-cell>
    </ng-container>

    <!-- Size Column -->
    <ng-container matColumnDef="Descarga">
        <mat-header-cell *matHeaderCellDef>
            <h2><b>{{'FILEMANAGER.LISTA.TITULOS.ACCIONES' | translate}}</b></h2>
        </mat-header-cell>
        <mat-cell *matCellDef="let fila" class="p-20" fxLayout="row" fxLayoutAlign="start center">
          <ng-container *ngIf="fila.tipoArchivo == 'vacio'; else c6_existe">
          </ng-container>
          <ng-template #c6_existe>
            <ng-container *ngIf="fila.tipoArchivo == 'folder'; else c6_archivo">
              <ng-container *ngIf="versionCloudNueva; else acciones_anterior">
                <!-- <button *ngIf="!fila.carpetaDef" mat-mini-fab matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DELETE' | translate}}" (click)="borraArchivo(fila._id,2)" color="warn" class="mr-20">
                  <mat-icon>delete_forever</mat-icon>
                </button> -->
              </ng-container>
              <ng-template #acciones_anterior>
                <button *ngIf="!fila.carpetaDef" mat-mini-fab matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DELETE' | translate}}" (click)="borraArchivo(fila._id,2)" color="warn" class="mr-20">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </ng-template>
            </ng-container>
            <ng-template #c6_archivo>
              <ng-container *ngIf="versionCloudNueva; else acciones_anterior">
                <a *ngIf="!fila.archivoDef" mat-mini-fab color="primary" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DESCARGA' | translate}}" class="mr-20" href="{{urlFileServer}}{{fila.ubicacion + '/' + fila.nombreArchivoCode}}" target="_blank" download>
                  <mat-icon>get_app</mat-icon>
                </a>
                <a *ngIf="fila.archivoDef" mat-mini-fab color="primary" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DESCARGA' | translate}}" class="mr-20" href="{{fila.ubicacion + fila.nombre}}" target="_blank" download>
                  <mat-icon>get_app</mat-icon>
                </a>
                <button *ngIf="puedeBorrar && !fila.archivoDef" mat-mini-fab matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DELETE' | translate}}" (click)="nuevo_borraArchivo(fila.ubicacion + '/' + fila.nombre,1)" color="warn">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </ng-container>
              <ng-template #acciones_anterior>
                <a *ngIf="!fila.archivoDef" mat-mini-fab color="primary" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DESCARGA' | translate}}" class="mr-20" href="{{htp}}{{urlServidor}}{{urlFileManager}}{{fila.ubicacion + fila.nombre}}" target="_blank" download>
                  <mat-icon>cloud_download</mat-icon>
                </a>
                <a *ngIf="fila.archivoDef" mat-mini-fab color="primary" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DESCARGA' | translate}}" class="mr-20" href="{{fila.ubicacion + fila.nombre}}" target="_blank" download>
                  <mat-icon>cloud_download</mat-icon>
                </a>
                <button *ngIf="puedeBorrar && !fila.archivoDef" mat-mini-fab matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DELETE' | translate}}" (click)="borraArchivo(fila._id,1)" color="warn">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </ng-template>
            </ng-template>
          </ng-template>

            <!-- <ng-container *ngIf="fila.tipoArchivo != 'folder'">
            </ng-container>
            <ng-container *ngIf="fila.tipoArchivo == 'folder'">

            </ng-container> -->

        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="nombresColumnas"></mat-header-row>
    <mat-row *matRowDef="let fila; columns: nombresColumnas;" [ngClass]="{'selected' : fila == selected}" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
    </mat-row>
</mat-table>

<ng-container *ngIf="cargandoArchivos">
  <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
      <h2>{{'FILEMANAGER.CARGA.CARGANDOTIT' | translate}}</h2>
      <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
  </div>
</ng-container>
